import { navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import { useQueryClient } from "@trueskin-web/apis"
import { Button, Container, Heading } from "@trueskin-web/components"
import { useAuth } from "@trueskin-web/context"
import { storageService } from "@trueskin-web/services"
import { Routes, Trans } from "@trueskin-web/translations"

const storageKeys = storageService.getStorageKeys()

const BdAppSelectionScreen = () => {
  const queryClient = useQueryClient()

  const { user } = useAuth()
  const handleRedoQ = () => {
    // navigate(Routes.App.Diagnose.url + "?to=bd", { replace: true })
    navigate(Routes.App.Diagnose.url, { replace: true })
  }

  return (
    <Container>
      <div
        sx={{
          py: 6,
          display: "grid",
          gap: [5, "40px"],
        }}
      >
        <div
          sx={{
            display: "grid",
            gridTemplateColumns: ["none", "auto 1fr"],
            gap: 4,
          }}
        >
          <div>
            <Heading
              sx={{
                fontSize: ["32px", 6],
              }}
            >
              <Trans
                i18nKey="Start.BdWelcome.title"
                values={{
                  firstName: storageService.getItem({
                    id: storageKeys.FIRSTNAME,
                  }),
                }}
              />
            </Heading>
            <div
              sx={{
                fontSize: [3, 4],
                color: "textDark",
                mt: 4,
              }}
            >
              <Trans i18nKey="Start.BdWelcome.description" />
            </div>
          </div>
        </div>
        <div
          sx={{
            display: "grid",
            gridTemplateAreas: [
              '"heading" "appButton" "qButton"',
              '"heading ." "qButton appButton"',
            ],
            gap: 4,
          }}
        >
          <div
            sx={{
              display: "grid",
              gridTemplateColumns: ["80px 1fr", "none"],
              gap: 4,
              border: "1px",
              borderColor: "grey",
              p: 4,
              borderRadius: "8px",
              alignItems: "center",
              flexGrow: 1,
              gridArea: "qButton",
            }}
          >
            <div
              sx={{
                aspectRatio: 88 / 72,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
              }}
            >
              <StaticImage
                src={"../../images/tofu-welcome-bd-variant.jpeg"}
                alt=""
                sx={{
                  aspectRatio: 88 / 72,
                  maxHeight: 365,
                }}
              />
            </div>
            <div
              sx={{
                fontSize: 1,
                lineHeight: "body",
                display: "flex",
                justifyContent: [null, "center"],
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <div sx={{ marginTop: 2, textAlign: "left" }}>
                <div>
                  <Button
                    variant="link"
                    size="sm"
                    sx={{
                      color: "black",
                      p: 0,
                      fontWeight: "bold",
                      textAlign: "left",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    data-testid="web-portal-bd-welcome-bd-link"
                    onClick={handleRedoQ}
                  >
                    <Trans i18nKey="Start.BdWelcome.questionnaire.link" />
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div
            sx={{
              display: "grid",
              gridTemplateColumns: ["80px 1fr", "none"],
              gap: 4,
              border: "1px",
              borderColor: "grey",
              p: 4,
              borderRadius: "8px",
              alignItems: "center",
              flexGrow: 1,
              gridArea: "appButton",
            }}
          >
            <div
              sx={{
                aspectRatio: 88 / 72,

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                borderRadius: "8px",
              }}
            >
              <StaticImage
                src={"../../images/core-set.png"}
                alt=""
                sx={{
                  aspectRatio: 88 / 72,
                  maxHeight: 365,
                }}
              />
            </div>
            <div
              sx={{
                fontSize: 1,
                lineHeight: "body",
                display: "flex",
                justifyContent: [null, "center"],
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <div sx={{ marginTop: 2, textAlign: "left" }}>
                <div>
                  <Button
                    data-testid="web-portal-bd-welcome-core-link"
                    variant="link"
                    size="sm"
                    sx={{
                      color: "black",
                      p: 0,
                      fontWeight: "bold",
                      textAlign: "left",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    onClick={() => {
                      queryClient.setQueryData("currentUser", {
                        ...user,
                        redoInitialQuestionnaire: true,
                      })
                      navigate(Routes.App.url + "?to=core", {
                        replace: true,
                      })
                    }}
                  >
                    <Trans i18nKey="Start.BdWelcome.plan.link" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default BdAppSelectionScreen
